import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconGpsFixedComponent } from "./med-icon-gps-fixed.component";

@NgModule({
  declarations: [
    MedIconGpsFixedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconGpsFixedComponent,
  ],
})
export class MedIconGpsFixedModule { }
